import React from "react";
import styled from "@emotion/styled";

import { ColorWithSize, Condition } from "@pages/register/_components/index";
import BasicButton from "@components/button/BasicButton";
import { useFormContext } from "react-hook-form";
import useProductEditStepStore from "@store/productEdit/useProductEditStepStore";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
});

const ProductEditStepTwo = () => {
  const { trigger } = useFormContext();
  const { increaseStep } = useProductEditStepStore();

  const valid = async () => {
    const isStepValid = await trigger(["stock_list", "product_condition"]);

    if (isStepValid) {
      increaseStep();
    }
  };

  return (
    <Container>
      <ColorWithSize />

      <Condition />

      <BasicButton
        title="다음"
        height="5.2rem"
        width="100%"
        padding="1.6rem 1.2rem"
        onClick={valid}
        // disabled={!stockList?.length || !productCondition}
      />
    </Container>
  );
};

export default ProductEditStepTwo;
